import { Grid, Typography } from '@mui/material';
import { EmptyStateDetailsDrawerBackground } from '../../assets/images';
import { themeObject } from 'lib';

const styles = {
    emptyStateContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: '7.5px',
        mb: '38.5px',
    },
    emptyStateText: {
        fontFamily: 'Raleway',
        fontWeight: '500',
        fontSize: ' 20px',
        lineHeight: '23.48px',
        color: themeObject.palette.primary[700],
    },
};

export const EmptyStateDrawerDetails = (): React.JSX.Element => {
    return (
        <Grid sx={styles.emptyStateContainer}>
            <Grid>
                <img
                    src={EmptyStateDetailsDrawerBackground}
                    alt='Empty State Background'
                />
            </Grid>
            <Grid mt={2}>
                <Typography sx={styles.emptyStateText}>
                    Nothing to see here.
                </Typography>
            </Grid>
        </Grid>
    );
};
